import React from "react";
import styles from "./index.module.scss";

export default function Jumbotron(props) {
  const { children } = props;
  return (
    <section className={styles.container}>
      <div className="container">
        {children}
        {/*<div className={styles.icon1} />
                <div className={styles.icon2} />
                <div className={styles.icon3} />*/}
      </div>
    </section>
  );
}
